import React , {useState, useMemo, useEffect} from 'react';
import Val from "./ValueObj";
import {isTooLarge, DEFAULT_NODE_LIMIT} from "../utils/json";

const MainTable = ({jsonObj}) => {
    const [collapseAll, setCollapseAll] =  useState(false)
    const [forceRender, setForceRender] = useState(false)

    const tooLarge = useMemo(() => isTooLarge(jsonObj), [jsonObj])

    // Reset the "render anyway" override whenever new JSON is loaded.
    useEffect(() => { setForceRender(false) }, [jsonObj])

    const isEmpty = jsonObj === undefined || jsonObj === null

    return (
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h3 className="card-title">Json Tabular Form</h3>
                <div className={"card-subtitle"}>
                   <i
                      className={collapseAll?'mdi mdi-arrow-down-drop-circle-outline hover-cursor':"mdi mdi-arrow-up-drop-circle-outline hover-cursor"}
                      onClick={()=>setCollapseAll(!collapseAll)}> {collapseAll?"Expand All":"Collapse All"} </i>
               </div>

              {isEmpty ?
                <div className="text-muted text-center" style={{padding: '40px 0'}}>
                    No JSON to display yet. Paste or type JSON on the left and click <strong>Generate</strong>,
                    or load one of the example JSONs.
                </div>
              : tooLarge && !forceRender ?
                <div className="text-warning" style={{padding: '10px 0'}}>
                    This JSON is very large ({'>'}{DEFAULT_NODE_LIMIT.toLocaleString()} nodes) and rendering it as a table may make the page unresponsive.
                    <button className="btn btn-sm btn-warning btn-rounded ms-2"
                            onClick={() => setForceRender(true)}>Render anyway</button>
                </div>
              :
              <div className="table-responsive">
                <table className="outPut-table-main">
                  <tbody>
                    <tr>
                      <td colSpan="2">
                        <Val collapseAll={collapseAll} value={jsonObj}/>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              }
            </div>
          </div>
        </div>
    )
}


export default MainTable;
